<template>
  <form>
    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>
    
    <h4 class="header-title mt-0">{{$t('user.form.user_information')}}</h4>
    <p class="sub-header"></p>
    <div class="row">
      
      <DropDown 
        class="col-12 mt-2"
        :placeholder="$t('user.form.access_type.placeholder')"
        :label="$t('user.form.access_type.label')"
        :name.sync="model.access_type"
        :error="$v.model.access_type.$error"
        :errorMessage="$v.model.access_type.errorMessage"
        :options="access_type_options" 
      />

      <DropDown 
        class="col-12"
        :placeholder="$t('user.form.recruitment_type.placeholder')"
        :label="$t('user.form.recruitment_type.label')"
        :name.sync="model.recruitment_type"
        :options="recruitment_type_options"
        v-if="model.access_type == 'recruitment'"
      />

      <TextField 
        class="col-6"
        :placeholder="$t('user.form.first_name.placeholder')"
        :label="$t('user.form.first_name.label')"
        v-model="model.first_name"
        :error="$v.model.first_name.$error"
        :errorMessage="$v.model.first_name.errorMessage"
        type="text"
        v-if="parameters.type != 'company'"
      />

      <TextField 
        class="col-6"
        :placeholder="$t('user.form.last_name.placeholder')"
        :label="$t('user.form.last_name.label')"
        v-model="model.last_name"
        :error="$v.model.last_name.$error"
        :errorMessage="$v.model.last_name.errorMessage"
        type="text"
        v-if="parameters.type != 'company'"
      />

      <TextField 
        class="col-12"
        :placeholder="$t('user.form.company_name.placeholder')"
        :label="$t('user.form.company_name.label')"
        v-model="model.company_name"
        :error="$v.model.company_name.$error"
        :errorMessage="$v.model.company_name.errorMessage"
        v-if="parameters.type == 'company'"
      />

      <Multiselect
        autoload
        hasCheckbox
        hasSelectAll
        :limit="2"
        class="col-12"
        moduleName="industry"
        endpoint="all"
        v-model="model.industry_id"
        :searchable="true"
        :multiple="true"
        :placeholder="$t('user.form.industry.placeholder')"
        :clear-on-select="false"
        :close-on-select="true"
        :show-labels="false"
        track-by="_id"
        label="name"
        :textLabel="$t('user.form.industry.label')"
      />

      <Multiselect
        autoload
        hasCheckbox
        hasSelectAll
        :limit="2"
        class="col-12"
        moduleName="function"
        endpoint="all"
        v-model="model.function_id"
        :searchable="true"
        :multiple="true"
        :placeholder="$t('user.form.function.placeholder')"
        :clear-on-select="false"
        :close-on-select="true"
        :show-labels="false"
        track-by="_id"
        label="name"
        :textLabel="$t('user.form.function.label')"
      />

      <Multiselect
        autoload
        hasCheckbox
        hasSelectAll
        :limit="2"
        class="col-12"
        moduleName="brand"
        endpoint="all"
        v-model="model.brand_id"
        :searchable="true"
        :multiple="true"
        :placeholder="$t('user.form.brand.placeholder')"
        :clear-on-select="false"
        :close-on-select="false"
        :show-labels="false"
        track-by="_id"
        label="name"
        :textLabel="$t('user.form.brand.label')"
      />
    </div>
    <h4 class="header-title mt-0 mb-1">{{ $t('user.form.commission_setup') }}</h4>
    <p class="sub-header"></p>
    <div class="row">

      <b-form-checkbox
        class="my-2 ml-3 col-12"
        v-model="model.fixed" 
        name="check-button" 
        switch
        >
        {{$t('user.form.use_fixed_rate')}}
      </b-form-checkbox>

      <TextField 
        :max="model.fixed ? 0 : 100"
        :placeholder="model.fixed ? 'xx,xxx' : '%'"
        :label="$t('user.form.commission_rate.label')"
        type="number"
        class="col-md-12"
        v-model="model.rate"
        v-if="user.role.role === 'administration'"
      />

      <!-- <File
        class="col-12 mb-2"
        ref="files"
        file-size=5
        accept=".pdf, .jpg"
        v-model="model.files"
        :placeholder="$t('user.form.upload_document')"
      /> -->

      <DateTime
        class="col-12"
        v-model="model.contract_start_date"
        :placeholder="$t('user.form.contract_start_date.placeholder')"
        :label="$t('user.form.contract_start_date.label')"
        v-if="type == 'company'"
      />
      <DateTime
        class="col-12"
        v-model="model.contract_end_date"
        :placeholder="$t('user.form.contract_end_date.placeholder')"
        :label="$t('user.form.contract_end_date.label')"
        v-if="type == 'company'"
      />
    </div>
    <h4 class="header-title mt-0 mb-1">{{ $t('user.form.security_settings') }}</h4>
    <p class="sub-header"></p>
    <div class="row">
    

      <TextField 
        class="col-12 mt-2"
        placeholder="hello@hrtech.com"
        :label="$t('user.form.email.label')"
        type="email"
        autocomplete="off"
        v-model="model.email"
        :error="$v.model.email.$error"
        :errorMessage="$v.model.email.errorMessage"
      />

      <TextField 
        class="col-12"
        :placeholder="$t('user.form.password.placeholder')"
        :label="$t('user.form.password.label')"
        type="password"
        autocomplete="off"
        v-model="model.password"
        :error="$v.model.password.$error"
        :errorMessage="passwordError"
      />

      <TextField 
        class="col-12"
        :placeholder="$t('user.form.confirm_password.placeholder')"
        :label="$t('user.form.confirm_password.label')"
        type="password"
        :value="model.confirm_password"
        v-model="model.confirm_password"
        :error="$v.model.confirm_password.$error"
      />

      <!-- <vue-editor height="300"
        class="col-12"
        placeholder="Enter Company Description"
        v-if="type == 'company'"
        v-model="model.company_details">
      </vue-editor> -->
    </div>
  </form>
</template>

<script>
import TextField from '@components/form2/textfield.vue'
import DropDown from '@components/form2/dropdown.vue'
import DateTime from '@components/form2/dateTime.vue'
import  FormMixin from '@mixins/form'
import Multiselect from '@components/form2/select/multiselect'

import { required, email, sameAs, requiredIf} from 'vuelidate/lib/validators'
// import { VueEditor } from 'vue2-editor'
// import File from '@components/form2/file2'
export default {
  mixins: [FormMixin],
  components:{
    TextField, 
    DropDown, 
    // VueEditor,
    Multiselect,
    DateTime,
    // File
  },
  props:{
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    type() {
      let parameters = this.parameters || {}
      return parameters.type || ''
    },
    userData () {
      let parameters = this.parameters || {}
      return parameters.userData || {}
    },
    pId() {
      let parameters = this.parameters || {}
      return parameters.id
    }
  },
  data(){
    // var aoptions = [{ value: null, text: 'Please select a Type' }]
    // let parameters = this.parameters || {}
    // let { type, userData } = parameters
    
    // if(type == 'users'){
    //   if(userData.access_type == 'administration'){
    //     aoptions.push({ value: 'administration', text: 'Administrator' })
    //   }
    //   aoptions.push({ value: 'staff', text: 'Staff' })
    // }

    //aoptions.push({ value: 'recruitment', text: 'Recruitment' })
    return {
      model:{
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: '',
        access_type:null,
        recruitment_type:null,
        contract_start_date: '',
        contract_end_date: '',
      },
      industry_options:[],
      function_options:[],
      brand_options:[],
      source_options:[],
      access_type_options: [],
      recruitment_type_options: [
        { value: null, text: 'Please select a Type' },
        { value: 'company', text: 'Company' },
        { value: 'individual', text: 'Individual' }
      ],
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      contains: {
        upper: '',
        lower: '',
        number: '',
        special: '',
        length: ''
      },
      passwordError: ''
    }
  },
  validations: {
    model:{
      first_name: { 
        required: requiredIf(function(){
          return this.parameters.type != 'company'
        })
       },
      last_name: { 
        required: requiredIf(function(){
          return this.parameters.type != 'company'
        })
      },
      company_name:{
        required: requiredIf(function(){
          return this.parameters.type == 'company'
        })
      },
      email: {
        required,
        email
      },
      password: {
        required,
        passwordRule: function(value) {
          let valid = (/[A-Z]/.test(value) && /[a-z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*-]/.test(value) && value.length > 5)

          this.passwordError = (valid ? '' : 'Password must have at least (') + 
          (value.length > 5 ? '' : 'length of 6 characters; ') + 
          (/[A-Z]/.test(value) ? '' : '1 upper case letter; ') + 
          (/[a-z]/.test(value) ? '' : '1 lower case letter; ') + 
          (/[0-9]/.test(value)  ? '' : '1 number; ') + 
          (/[#?!@$%^&*-]/.test(value) ? '' : '1 special character') + 
          (valid ? '' : ')')
          
          return /[A-Z]/.test(value) && /[a-z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*-]/.test(value) && value.length > 5
        }
      },
      access_type: {
        required: requiredIf(function(){
          return this.parameters.type == 'users'
        })
      },
      confirm_password: {
        sameAsPassword: sameAs('password')
      }
    }
  },
  async created(){
    await this.$store.dispatch('industry/all').then(data => {
      data.data.forEach(el => {
        this.industry_options.push(el)
      })
    })
    // let type = this.parameters.type == 'users' ? 5 : this.parameters.type == 'company' ? 2 : this.parameters.type == 'individual' ? 3 : 3
    await this.$store.dispatch('role/get').then(data => {
      data.data.forEach(el => {
        this.access_type_options.push({ value: el._id, text: el.name })
      })
    })
    
    await this.$store.dispatch('user/candidate_source').then(data => {
      data.data.forEach(el => {
        this.source_options.push({ value: el.name, text: el.name })
      })
    })

    await this.$store.dispatch('function/all').then(data => {
      data.data.forEach(el => {
        this.function_options.push(el) 
      })
    })

    await this.$store.dispatch('function/all_brand').then(data => {
      data.data.forEach(el => {
        this.brand_options.push(el)
      })
    })
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods:{
    onView() {
      this.$router.push('/administration/user')
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
  },
  watch:{
    'model.access_type':{
      handler: function() {
        if(this.model.access_type != 'recruitment_type'){
          this.model.recruitment_type = null
        }
      }
    }
  }
}
</script>

<style lang="scss">

label {
    font-size: 11px;
    font-weight: 500;
    display: inline-block;
    margin-bottom: .5rem;
}
// .form-box {
//     box-shadow: none !important;

// }
</style>